export const whereWeWorksSubmenu = [
  {
    label: "Where we work",
    link: "#where-we-works",
  },
  {
    label: "Overview",
    link: "#overview",
  },
  {
    label: "KPIs",
    link: "#kpis",
  },
];
